var _defs, _rect, _path, _path2, _path3, _line, _line2, _line3, _path4, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96129(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "taustavalko",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-96-034-1,.cls-96-034-3{fill:none;}.cls-96-034-2{fill:none;}.cls-96-034-2,.cls-96-034-3{stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-96-034-1",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-96-034-2",
    d: "M88,48.09,70.71,56.91l-8.79-8S55.47,42.4,49.2,38.76c-3-1.71-6.91,1.66-8.5,2.78a8.88,8.88,0,0,1-2.18,1.14c-1.49.18-4.72.16-5.05-3.13-.43-4.29,11.27-11,13.09-11s14.49,6,16.21,6.44,13.72-6.44,13.72-6.44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96-034-2",
    d: "M9.75,46.92c0,.21.89.59,1.08.71l3,1.85,4.42,2.75,5.39,3.35,5.9,3.66,6,3.69L41,66.37l4.66,2.9c1.12.69.32-.53,1.43.16A9.87,9.87,0,0,0,51.37,71c3.25.32,3.17-3.29,3.17-3.29s2.65,1,4.2.26,1.51-3.61,1.51-3.61c.65,0,4.16.7,5.13-.22s-.39-4.32-.67-4.36c1.08.15,3.54,2.7,6.09.44C72.2,59,70.71,57,70.71,57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96-034-2",
    d: "M42.47,30.35S31.08,33.44,30,33.44s-8.46-5-8.46-5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-96-034-2",
    x1: 64.71,
    y1: 59.73,
    x2: 58.11,
    y2: 54.63
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-96-034-2",
    x1: 60.14,
    y1: 64.09,
    x2: 53.26,
    y2: 59
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-96-034-2",
    x1: 54.54,
    y1: 67.66,
    x2: 49.2,
    y2: 64.47
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96-034-3",
    d: "M27.32,59.52c-2.11-1.61-1.69-4.87,1.23-6.7l2.91-2.11a8.52,8.52,0,0,1,3.82-1.63c3-.44,3.14,3,3.14,3s2.37-1.12,3.85-.42,1.64,3.4,1.64,3.4c.61,0,3,.11,3.93,1s1.64,3.16,1.38,3.21a3.19,3.19,0,0,1,3.07,1.28,3,3,0,0,1,.15,3.13l-5.5,5c-1.07,1-2.84,2.19-5.11.49L33.7,64.49a5.5,5.5,0,0,1-1.25-1Z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-96-034-2",
    x1: 49.51,
    y1: 58.96,
    x2: 39.69,
    y2: 67.52
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-96-034-2",
    x1: 43.83,
    y1: 55.3,
    x2: 33.7,
    y2: 64.49
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-96-034-2",
    x1: 38.42,
    y1: 52.11,
    x2: 28.68,
    y2: 59.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96129);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_129.0a71c4c52c01f6de77a6b1a86eb52051.svg";
export { ForwardRef as ReactComponent };